import React from "react";

import "./tooltip.scss";
import classnames from "classnames";

export const Tooltip = ({ text, children, position, classes = "", asWarning, asError }) => {
    return (
        <div className={`tooltip ${classes}`}>
            {text && (
                <span
                    className={classnames({
                        text: true,
                        "text-warning": asWarning,
                        "text-error": asError,
                        [`-${position}`]: position,
                    })}
                >
                    {text}
                </span>
            )}
            {children}
        </div>
    );
};
